import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiLoader, TuiDropdown, TuiLink, TuiButton, TuiHint } from '@taiga-ui/core';
import { WaIntersectionObserver } from '@ng-web-apis/intersection-observer';
import { ComponentsModule } from '@src/app/components';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';
import { ActionsModule } from '@src/app/modules/actions/';
import { ImagesGroupViewModule } from '@src/app/modules/images-group-view';
import { EmojiModule } from '@src/app/modules/internal-messenger/emoji';
import { ReactionModule } from '@src/app/modules/internal-messenger/reaction';

import { PipesModule } from '../pipes';

import { MessagesListComponent } from './messages-list/messages-list.component';
import { MessageWrapperComponent } from './message-wrapper/message-wrapper.component';
import { MessageTextComponent } from './message-text/message-text.component';
import { MessageReplyComponent } from './message-reply/message-reply.component';
import { MessageFooterComponent } from './message-footer/message-footer.component';
import { MessageFileComponent } from './message-file/message-file.component';
import { DownloadFileButtonComponent } from './download-file-button/download-file-button.component';
import { MessageImageComponent } from './message-image/message-image.component';
import { MessageTailComponent } from './message-tail/message-tail.component';
import { MessageCustomComponent } from './message-custom/message-custom.component';
import { GenerateColorPipe } from './pipes';

@NgModule({
  declarations: [
    MessagesListComponent,
    MessageWrapperComponent,
    MessageTextComponent,
    MessageReplyComponent,
    MessageFooterComponent,
    MessageFileComponent,
    MessageImageComponent,
    MessageCustomComponent,
    DownloadFileButtonComponent,
    MessageTailComponent,
    GenerateColorPipe,
  ],
  imports: [
    CommonModule,
    TuiLoader,
    ...TuiDropdown,
    TuiButton,
    TuiLink,
    ComponentsModule,
    SharedModule,
    IconModule,
    ActionsModule,
    ImagesGroupViewModule,
    EmojiModule,
    ReactionModule,
    ...TuiHint,
    ...WaIntersectionObserver,
    PipesModule,
  ],
  exports: [
    MessagesListComponent,
    MessageWrapperComponent,
    MessageTextComponent,
    MessageReplyComponent,
    MessageFooterComponent,
  ],
})
export class MessageModule {}
